{
  "list": {
    "title": "Profesori",
    "add": "Adaugă profesor"
  },
  "columns": {
    "name": "Nume",
    "email": "E-mail",
    "payType": "Tip de plată",
    "payRate": "Tarif"
  },
  "payType": {
    "perClass": "Per ședință",
    "monthlySalary": "Salariu lunar"
  },
  "form": {
    "heading": "Adaugă profesor",
    "firstName": "Prenume",
    "lastName": "Nume",
    "email": "E-mail",
    "payType": "Tip de plată",
    "payRate": "Tarif",
    "currency": "Monedă",
    "create": "Creează",
    "nameEmailRequired": "Numele și e-mailul sunt obligatorii"
  },
  "toast": {
    "created": "Profesor creat",
    "failed": "A eșuat"
  },
  "detail": {
    "backToList": "Profesori",
    "email": "E-mail",
    "phone": "Telefon",
    "payType": "Tip de plată",
    "payRate": "Tarif",
    "assignedClasses": "Clase alocate",
    "noClasses": "Nicio clasă alocată",
    "columns": {
      "class": "Clasă",
      "day": "Zi",
      "time": "Oră",
      "enrolled": "Înscriși"
    }
  },
  "invite": {
    "heading": "Acces cont",
    "canLogin": "Se poate autentifica",
    "canLoginHint": "Acest profesor și-a setat o parolă și se poate autentifica.",
    "noLogin": "Fără autentificare încă",
    "noLoginHint": "Trimite o invitație pentru ca profesorul să-și seteze o parolă și să se autentifice.",
    "send": "Trimite invitație de autentificare",
    "resend": "Resetează parola",
    "sent": "Link de invitație generat.",
    "copy": "Copiază",
    "copied": "Link copiat.",
    "emailedNote": "Am trimis acest link profesorului prin email. Îl poți și copia:",
    "copyNote": "Emailul nu este configurat — distribuie acest link profesorului:"
  }
}
